"use strict";
var food = {
    Drink: {
        Wine: {},
        Schnaps: {}
    },
    Fruit: {
        Red: {
            Cherry: {},
            Strawberry: {}
        },
        Yellow: {
            Banana: {},
            Pineapple: {}
        }
    }
};
var tree = document.querySelector("#tree");
function createTree(element, data) {
    var ul = document.createElement("ul");
    for(var key in data){
        if (!data.hasOwnProperty(key)) continue;
        var li = document.createElement("li");
        li.textContent = key;
        var value = data[key];
        if (typeof value === "object" && value !== null && Object.keys(value).length > 0) createTree(li, value);
        ul.appendChild(li);
    }
    // 5️⃣ Додаємо готовий список в element
    element.appendChild(ul);
}
createTree(tree, food);

//# sourceMappingURL=index.c80862dd.js.map
